import { Component, ComponentChild, h } from 'preact'
import axios from 'axios'
import FeaturedSidebar from './featuredSidebar'
import FeaturedBanner from './featuredBanner'

type FeaturedTopicData = {
  firstPost: {
    author: string,
    relativeCreationDate: string
  },
  url: string,
  title: string
}

type widgets = {
  featuredSide: ComponentChild,
  featuredBanner: ComponentChild
}

type widgetTypes = 'featuredBanner' | 'featuredSide'

const showWidget = (widget: widgetTypes, data: Array<FeaturedTopicData>): ComponentChild => {
  const widgetComponents: widgets = {
    featuredSide: <FeaturedSidebar data={data} />,
    featuredBanner: <FeaturedBanner data={data} />
  }

  return widgetComponents[widget]
}

interface Props {
  widget: widgetTypes
}

interface State {
  data: Array<FeaturedTopicData>
}

class FeaturedTopicsWrapper extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      data: []
    }
  }

  async componentDidMount () {
    const res = await axios.get(`/widget/${this.props.widget}`)
    this.setState({ data: res.data })
  }

  render ({ widget }: Props, { data }: State) {
    if (!data.length) {
      return null
    }
    return (
      <div className={widget}>
        {showWidget(widget, data)}
      </div>
    )
  }
}

export default FeaturedTopicsWrapper
